import React from "react";
import DatePicker from "react-datepicker";
import node from "detect-node";

class DateRange extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			startDate: null,
			endDate: null,
		};
	}

	render() {
		const { startDate, endDate, dateChange, search, maxDate } = this.props;
		return (
			<div className="uk-margin-medium-bottom uk-margin-medium-top">
				{!node && (
					<div className="uk-flex uk-flex-middle">
						<DatePicker
							dateFormat="dd MMM yyyy"
							selected={startDate}
							onChange={dateChange}
							startDate={startDate}
							endDate={endDate}
							maxDate={maxDate}
							selectsRange
							isClearable={true}
							className={"uk-input uk-width-medium"}
							placeholderText="Start Date"
						/>
						<button
							className="uk-button uk-button-small uk-button-primary uk-margin-left action-btn"
							type="button"
							onClick={search}
						>
							<span className="uk-text-middle uk-text-bold">Search</span>
						</button>
					</div>
				)}
			</div>
		);
	}
}

export default DateRange;
